import Breadcrumb from '@/components/base/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';
import ContactForm from './components/ContactForm';
import { aboutData } from '@/mocks/about';

export default function About() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 - 蓝色导航发布页',
          description: '了解蓝色导航发布页的品牌故事、核心价值观和联系方式。',
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          items: [
            { name: '首页', url: '/' },
            { name: '关于我们', url: '/about' },
          ],
        }}
      />

      <main className="pt-16">
        <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

        <section className="w-full px-4 md:px-6 py-10 md:py-16 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="mb-16">
              <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading mb-4">
                关于{aboutData.brandName}
              </h1>
              <p className="text-foreground-600 text-base md:text-lg max-w-3xl">
                {aboutData.tagline} &mdash; {aboutData.mission}
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mb-16">
              {aboutData.achievements.map((item) => (
                <div key={item.label} className="text-center p-6 bg-background-100 rounded-lg">
                  <div className="text-2xl md:text-3xl font-bold text-primary-600 font-heading mb-1">
                    {item.number}
                  </div>
                  <div className="text-sm text-foreground-500 whitespace-nowrap">{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-6">
                  我们的故事
                </h2>
                <div className="space-y-4 text-foreground-600 text-sm md:text-base leading-relaxed">
                  {aboutData.story.split('\n\n').map((para, i) => (
                    <p key={i}>{para}</p>
                  ))}
                </div>
              </div>
              <div className="aspect-[4/3] rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20creative%20office%20space%20with%20team%20collaboration%2C%20warm%20natural%20light%20streaming%20through%20large%20windows%2C%20clean%20white%20and%20wood%20interior%2C%20professional%20creative%20environment%2C%20casual%20brainstorming%20atmosphere&width=800&height=600&seq=about-story-01&orientation=landscape"
                  alt="蓝色导航发布页团队"
                  title="蓝色导航发布页 - 我们的团队"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12">
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
                核心价值观
              </h2>
              <p className="text-foreground-600 text-sm md:text-base">
                这些信念指引着我们每一天的工作和每一个决策
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {aboutData.values.map((value) => (
                <div
                  key={value.title}
                  className="bg-background-100 rounded-lg p-6 text-center"
                >
                  <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center bg-accent-100 rounded-full">
                    <i className={`${value.icon} text-2xl text-accent-600`}></i>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">
                    {value.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {value.description}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-6">
                  联系我们
                </h2>
                <p className="text-foreground-600 text-sm md:text-base mb-8">
                  如果您有任何问题、建议或合作意向，欢迎通过以下方式联系我们，或直接填写表单，我们会在24小时内回复。
                </p>

                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                      <i className="ri-mail-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-0.5 whitespace-nowrap">电子邮箱</h4>
                      <a href={`mailto:${aboutData.contact.email}`} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap">
                        {aboutData.contact.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                      <i className="ri-phone-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-0.5 whitespace-nowrap">服务热线</h4>
                      <span className="text-sm text-foreground-600 whitespace-nowrap">{aboutData.contact.phone}</span>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                      <i className="ri-map-pin-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-0.5 whitespace-nowrap">公司地址</h4>
                      <span className="text-sm text-foreground-600">{aboutData.contact.address}</span>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg flex-shrink-0">
                      <i className="ri-wechat-line text-primary-600 text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-900 mb-0.5 whitespace-nowrap">微信公众号</h4>
                      <span className="text-sm text-foreground-600 whitespace-nowrap">{aboutData.contact.wechat}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-8">
                <h3 className="text-lg font-semibold text-foreground-900 font-heading mb-6">发送消息</h3>
                <ContactForm />
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}